/**
 * مرشّح المدى التاريخي — يحل محل PeriodFilter
 * كل التواريخ ميلادية (انظر lib/date.ts)
 */
import React from "react";
import {
  todayISO, addDays, monthStartISO, monthEndISO, formatDate, daysInclusive,
} from "../../lib/date";

export interface DateRange { from: string; to: string }

const PRESETS: Array<{ label: string; range: () => DateRange }> = [
  { label: "اليوم",          range: () => ({ from: todayISO(),        to: todayISO() }) },
  { label: "غداً",           range: () => ({ from: addDays(todayISO(), 1), to: addDays(todayISO(), 1) }) },
  { label: "آخر 7 أيام",     range: () => ({ from: addDays(todayISO(), -6),  to: todayISO() }) },
  { label: "آخر 30 يوماً",   range: () => ({ from: addDays(todayISO(), -29), to: todayISO() }) },
  { label: "هذا الشهر",      range: () => ({ from: monthStartISO(),   to: monthEndISO() }) },
  { label: "الشهر الماضي",   range: () => ({ from: monthStartISO(-1), to: monthEndISO(-1) }) },
];

export const defaultRange = (): DateRange => ({ from: monthStartISO(), to: monthEndISO() });

export default function DateRangeFilter({
  value, onChange, disabled = false,
}: { value: DateRange; onChange: (r: DateRange) => void; disabled?: boolean }) {
  const invalid = value.from > value.to;

  return (
    <div className="card mb-4 space-y-3">
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => {
          const r = p.range();
          const active = r.from === value.from && r.to === value.to;
          return (
            <button key={p.label} type="button" disabled={disabled}
              onClick={() => onChange(r)}
              className={`px-3 py-1 text-xs rounded-full border transition disabled:opacity-50 ${
                active ? "bg-primary-600 text-white border-primary-600"
                       : "border-gray-300 text-gray-600 hover:border-primary-400"
              }`}>
              {p.label}
            </button>
          );
        })}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="rangeFrom">من تاريخ</label>
          {/* input[type=date] ميلادي دائماً بصرف النظر عن لغة المتصفح */}
          <input id="rangeFrom" type="date" className="input" dir="ltr" disabled={disabled}
            value={value.from} onChange={(e) => onChange({ ...value, from: e.target.value })} />
        </div>
        <div>
          <label className="label" htmlFor="rangeTo">إلى تاريخ</label>
          <input id="rangeTo" type="date" className="input" dir="ltr" disabled={disabled}
            value={value.to} onChange={(e) => onChange({ ...value, to: e.target.value })} />
        </div>
      </div>

      {invalid ? (
        <p className="text-xs text-red-600">تاريخ البداية يجب أن يسبق تاريخ النهاية</p>
      ) : (
        <p className="text-xs text-gray-500">
          {formatDate(value.from)} — {formatDate(value.to)}
          <span className="text-gray-400 mr-2">({daysInclusive(value.from, value.to)} يوماً، ميلادي)</span>
        </p>
      )}
    </div>
  );
}
